export const slideDown = (el: HTMLDivElement) => {
  el.style.height = `${el.scrollHeight}px`;
  setTimeout(() => (el.style.height = `auto`), 150);
  setTimeout(() => (el.style.overflow = `visible`), 150);
};

export const slideUp = (el: HTMLDivElement) => {
  el.style.height = `${el.scrollHeight}px`;
  setTimeout(() => (el.style.height = `0px`), 10);
  setTimeout(() => (el.style.overflow = `hidden`), 150);
};
